import LabeledSelect from "./LabeledSelect";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {loadSpecialBrands} from "../../redux/slices/searchSlice";
import CustomButton, {DangerButton} from "../CustomButton";

const SpecialBrandSelect = ({label, value, onChange, emptyMsg, isBrandDay, extData, ...props}) => {

  const {loading, data, error, init} = useSelector((state) => state.search.specialBrands);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(loadSpecialBrands());
  }, [dispatch, data, error]);

  useEffect(() => {
    if (extData && init){
      const selected = data.find((d)=>d.id === extData);
      if(onChange && selected){
        onChange(selected);
      }
    }

  }, [extData, init]);

  const retry = () => {
    dispatch(loadSpecialBrands());
  };

  return (

    error ?
      <div className="flex items-center justify-between border-gray-300 border-solid border px-2 rounded">
        <div className="text-error-100 ">{error}</div>
        <DangerButton onClick={retry}>Retry</DangerButton>
      </div> :
      <LabeledSelect label={label} value={value} loading={loading} getOptionLabel={(option) => option.name}
                     getOptionValue={(option) => option.id}
                     options={data?.filter((item) => isBrandDay === !!item.is_brand_day)}
                     onChange={onChange} emptyMsg={emptyMsg} {...props}/>


  );


};


export default React.memo(SpecialBrandSelect);
